"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const env_1 = require("./env");
let _init = false;
let _canLog = false;
const logger = (...message) => {
    if (env_1.isReactNative)
        return;
    if (typeof window === 'undefined')
        return;
    if (!_init) {
        const env = (0, env_1.getEnv)();
        _canLog = [env_1.ENV.SANDBOX, env_1.ENV.STAGE].includes(env);
        _init = true;
    }
    if (_canLog) {
        console.debug(message);
    }
};
exports.logger = logger;
//# sourceMappingURL=logger.js.map